import React, { useEffect, useRef } from 'react'
import './ChatHistory.scss'

export default function ChatHistory({ chat_history }) {
    const latest_message_ref = useRef(null)

    useEffect(() => {
        if (latest_message_ref.current) {
            latest_message_ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [chat_history])

    return (
        <div className="chat-history-sub-component-right-panel-component">
            {
                chat_history &&
                chat_history.map((item, index) => (
                    <Message
                        key={index}
                        message={item.message}
                        name={item.name}
                        time={item.time}
                        isMe={item.isMe}
                        logo={item.logo}
                        latest_ref={index === chat_history.length - 1 ? latest_message_ref : null}
                    />
                ))
            }
        </div>
    )
}

/**
 * Helper function to parse message text for:
 * 1. Markdown links: [text](URL)
 * 2. Direct URLs: https://...
 * 3. Bold text markers: **bold**
 */
function parseMessage(text) {
    // Explanation of the regex:
    // 1) \[([^\]]+)\]\(([^)]+)\) -> matches markdown links [label](url)
    // 2) (https?:\/\/[^\s]+)    -> matches plain URLs
    // 3) \*\*(.*?)\*\*         -> matches bold markers **bold text**
    const linkRegex = /\[([^\]]+)\]\(([^)]+)\)|(https?:\/\/[^\s]+)|\*\*(.*?)\*\*/g;
    const elements = [];
    let lastIndex = 0;
    let match;

    while ((match = linkRegex.exec(text)) !== null) {
        // Add any text before this match
        if (match.index > lastIndex) {
            elements.push(text.slice(lastIndex, match.index));
        }

        // match[1] & match[2] => [label](url)
        if (match[1] && match[2]) {
            elements.push(
                <a
                    key={match.index}
                    href={match[2]}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: 'blue' }}
                >
                    {match[1]}
                </a>
            );
        }
        // match[3] => direct URL (https://...)
        else if (match[3]) {
            elements.push(
                <a
                    key={match.index}
                    href={match[3]}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: 'blue' }}
                >
                    {match[3]}
                </a>
            );
        }
        // match[4] => bold text from **...**
        else if (match[4]) {
            elements.push(
                <strong key={match.index}>
                    {match[4]}
                </strong>
            );
        }

        lastIndex = linkRegex.lastIndex;
    }

    // Add any remaining text after the last match
    if (lastIndex < text.length) {
        elements.push(text.slice(lastIndex));
    }

    return elements;
}

const Message = ({ message, name, time, isMe, logo, latest_ref }) => {
    return (
        <div ref={latest_ref} className="chat-history-sub-component-right-panel-component-chat-item">
            <div className={"chat-item-wrapper" + (isMe ? " chat-item-wrapper-me" : "")}>
                <div className="chat-item-wrapper-header">
                    <div className="chat-item-wrapper-header-avatar">
                        <img src={logo} alt="" />
                    </div>
                    <div className="chat-item-wrapper-header-name font-bold">{name}</div>
                </div>
                <div className="chat-item-wrapper-content">
                    <div className="chat-item-wrapper-content-message">
                        {parseMessage(message)}
                    </div>
                </div>
            </div>
        </div>
    )
}
